'use client'

import { Container, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

const HolidayNote = () => {
  const experiment = useAbTest('dd_tx_unify_holiday_hint_in_conversation')

  useTrackAbTest(experiment)

  const translate = useTranslate()

  if (!experiment) return null
  if (experiment.variant !== 'on') return null

  return (
    <Container padding="regular">
      <Text as="span" type="subtitle" alignment="center" width="parent" theme="warning">
        {translate('conversation.composer.holiday_hint')}
      </Text>
    </Container>
  )
}

export default HolidayNote
